// extracted by mini-css-extract-plugin
export default {"wrapper":"Nav_wrapper__BzcGi","burger_item":"Nav_burger_item__W-mMn"};